import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("overview");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const offsets = navLinks.map((link) => {
        const el = document.getElementById(link.id);
        return { id: link.id, top: el ? el.getBoundingClientRect().top : Infinity };
      });
      const current = offsets.filter((item) => item.top <= 120).pop();
      if (current) setActive(current.id);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleJump = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-10">
        <button
          type="button"
          onClick={() => handleJump("overview")}
          className={`flex items-center gap-2 whitespace-nowrap font-heading text-lg font-semibold cursor-pointer ${
            scrolled ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <i className={`ri-film-line text-xl ${scrolled ? "text-primary-500" : "text-accent-400"}`}></i>
          善良的小姨子在线
        </button>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <li key={link.id}>
              <button
                type="button"
                onClick={() => handleJump(link.id)}
                className={`whitespace-nowrap rounded-md px-3 py-2 text-sm font-label transition-colors cursor-pointer ${
                  active === link.id
                    ? scrolled
                      ? "bg-primary-100 text-primary-700"
                      : "bg-background-50/15 text-background-50"
                    : scrolled
                      ? "text-foreground-700 hover:text-primary-600"
                      : "text-background-100/90 hover:text-background-50"
                }`}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={() => handleJump("playlines")}
          className={`hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 lg:inline-flex cursor-pointer ${
            scrolled ? "" : "ring-1 ring-background-50/30"
          }`}
        >
          立即播放
        </button>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md text-xl lg:hidden cursor-pointer ${
            scrolled ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 lg:hidden">
          <ul className="grid grid-cols-2 gap-2 pt-3">
            {navLinks.map((link) => (
              <li key={link.id}>
                <button
                  type="button"
                  onClick={() => handleJump(link.id)}
                  className={`w-full whitespace-nowrap rounded-md px-3 py-2 text-left text-sm font-label cursor-pointer ${
                    active === link.id
                      ? "bg-primary-100 text-primary-700"
                      : "bg-background-100 text-foreground-700"
                  }`}
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}